import { OrganizationMemberManager } from '@copilot/data';

export function disconnectMemberLinkedIn(memberId: string) {
	return OrganizationMemberManager.disconnectMemberLinkedIn(memberId);
}

export function clearMemberSalesNavMissingError(memberId: string) {
	return OrganizationMemberManager.resetMemberSalesNavErrorStatus(memberId);
}
